import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  DELETE_NOTIFY,
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  SHOW_SEND_NOTIFY_DIALOG,
  SEND_NOTIFY_HISTORY_DIALOG,
  FETCH_USER_NOTIFY_LIST,
  DELETE_USER_NOTIFY,
  READ_USER_NOTIFY,
  READ_USER_ALL_NOTIFY,
  FETCH_NOTIFY_CENTER_MESSAGE,
  FETCH_NO_DO_FEEDBACK_NUM
} from './actionTypes'
import * as services from './services'
import * as actions from './actions'
import { RTM_NOTIFY_CENTER_MESSAGE } from '@/models/socket/actionTypes'
//const tenantMode = process.env.APP_MODE === 'tenant'

export default {
  *[FETCH_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },
  *[DELETE_NOTIFY]({ payload }) { // 删除消息
    yield actions.toggleLoading()
    yield call(services.deleteNotify, payload.id)
    yield actions.toggleLoading()
    payload.callback && payload.callback()
  },
  *[DELETE_USER_NOTIFY]({ payload }) { // 删除用户消息
    yield actions.toggleLoading()
    yield call(services.deleteUserNotify, payload.id)
    yield actions.toggleLoading()
    payload.callback && payload.callback()
  },
  *[READ_USER_NOTIFY]({ payload }) { // 标记已读
    yield actions.toggleLoading()
    yield call(services.readUserNotify, payload.id)
    yield actions.toggleLoading()
    payload.callback && payload.callback()
  },
  *[READ_USER_ALL_NOTIFY]({ payload }) { // 标记用户的所有为已读
    yield actions.toggleLoading()
    yield call(services.readUserAllNotify)
    yield actions.toggleLoading()
    payload.callback && payload.callback()
  },
  *[FETCH_USER_NOTIFY_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.getUserNotify, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },
  *[SEND_NOTIFY_HISTORY_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('SEND_NOTIFY_HISTORY_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_SEND_NOTIFY_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('SEND_NOTIFY_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('NOTIFY_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[FETCH_NOTIFY_CENTER_MESSAGE]({ payload }) {
    const result = yield call(services.fetchNotifies, payload)
    yield put(actions.notifyFetched(result))
  },
  *[FETCH_NO_DO_FEEDBACK_NUM]({ payload }) {
    const result = yield call(services.fetchNoDoFeedback, payload)
    yield put(actions.noDoFeedback(result))
  },
  *[RTM_NOTIFY_CENTER_MESSAGE]({ payload }) {
    var audio = new Audio();
    let video = 'notify.mp3'
    audio.src = process.env.PUBLIC_URL + '/' + video;
    audio.play();
    audio.addEventListener('ended', () => {
      audio.remove();
    });
    const result = yield call(services.fetchNotifies, payload)
    yield put(actions.notifyFetched(result))
    yield put(actions.fetchUserNotifyList({ offset: 0, limit: 10 }))
  },
}
